import React from 'react'
import { Field } from 'redux-form/immutable'
import PlacesAutocomplete from 'react-places-autocomplete'

import InputText from '../InputText'
import ListItem from '../ListItem'

import enhance from './enhance'
import './styles.css'
import {
  InputWrap,
  PinIcon,
  List,
  LoadingSpinner,
  GoogleLogoContainer,
  Error,
} from './styles'

const InputLocation = ({
  input,
  onPinIconClick,
  label,
  validator,
  placeholder,
  className,
  slim,
  address,
  handleChange,
  handleOnSelect,
  disabled,
  handleOnFocus,
  handleOnFocusDefault,
  busy,
  placesRef,
  searchOptions,
  // blur not being used, see enhancer
  // handleBlur,
  locError,
}) => (
  <React.Fragment>
    <PlacesAutocomplete
      value={address}
      onChange={handleChange}
      onSelect={handleOnSelect}
      ref={placesRef}
      // this prop is required if we want to be able to select
      // the value on blur or <return>. either will only select the
      // suggestion if there is a suggestion ready to select.
      highlightFirstSuggestion={true}
      googleCallbackName="loadGoogleMaps"
      searchOptions={searchOptions}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <InputWrap
          onFocus={handleOnFocus || handleOnFocusDefault}
          // do not handle onBlur here because suggestions
          // will not get cleared even though the field looses focus.
        >
          <InputText
            {...input}
            {...getInputProps()}
            className={className}
            validator={validator}
            placeholder={placeholder}
            // onBlur={handleBlur}
            label={label}
            beforeIcon={
              busy ? (
                <LoadingSpinner />
              ) : (
                onPinIconClick && <PinIcon onClick={onPinIconClick} />
              )
            }
            data-testid="input_location"
            disabled={disabled}
            slim={slim}
          />
          {!!suggestions.length && (
            <List flush>
              {loading ? (
                <ListItem>Loading...</ListItem>
              ) : (
                <React.Fragment>
                  {suggestions.map((suggestion, sIdx) => (
                    <ListItem
                      {...getSuggestionItemProps(suggestion)}
                      key={sIdx}
                      data-testid={`info_locSuggestion_${sIdx}`}
                      active={suggestion.active}
                      fancyHighlight
                      highlight
                      className="sh-body"
                    >
                      {suggestion.description}
                    </ListItem>
                  ))}

                  <ListItem>
                    <GoogleLogoContainer>
                      <img
                        alt="google logo"
                        src="/assets/poweredByGoogle.png"
                      />
                    </GoogleLogoContainer>
                  </ListItem>
                </React.Fragment>
              )}
            </List>
          )}
        </InputWrap>
      )}
    </PlacesAutocomplete>
    {!!locError && <Error>{locError}</Error>}
    <Field
      type="hidden"
      component="input"
      name="street"
      data-testid="input_street"
      data-heap-redact-text="true"
    />
    <Field
      type="hidden"
      component="input"
      name="city"
      data-testid="input_city"
    />
    <Field
      type="hidden"
      component="input"
      name="state"
      data-testid="input_state"
    />
    <Field
      type="hidden"
      component="input"
      name="zip"
      data-testid="input_zip"
      validator="required"
    />
    <Field type="hidden" component="input" name="lat" data-testid="input_lat" />
    <Field type="hidden" component="input" name="lon" data-testid="input_lon" />
  </React.Fragment>
)

export default enhance(InputLocation)
